/** Live entered/exited/inside counts for today — polls every 30s. */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { LogIn, LogOut, Beef } from "lucide-react";

const Mini = ({ icon: Icon, label, value, testId }) => (
  <div className="bg-muted/40 rounded-2xl p-4" data-testid={testId}>
    <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground font-bold">
      <Icon className="w-3.5 h-3.5" /> {label}
    </div>
    <div className="font-display text-3xl font-extrabold mt-1">{value}</div>
  </div>
);

export default function GateActivityCard() {
  const { t } = useT();
  const [d, setD] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/subscriber/gate-activity")
      .then((r) => { if (alive) setD(r.data); })
      .catch(() => {});
    load();
    const timer = setInterval(load, 30000);
    return () => { alive = false; clearInterval(timer); };
  }, []);

  if (!d) return null;
  return (
    <div className="am-card p-6 mt-6" data-testid="gate-activity-card">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display text-xl font-bold">{t("sub.gateActivity")}</h2>
        <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-2.5 py-1">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" /> LIVE
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Mini icon={LogIn} label={t("sub.enteredToday")} value={d.entered_today} testId="gate-entered-today" />
        <Mini icon={LogOut} label={t("sub.exitedToday")} value={d.exited_today} testId="gate-exited-today" />
        <Mini icon={Beef} label={t("sub.currentlyInside")} value={d.currently_inside} testId="gate-currently-inside" />
      </div>
    </div>
  );
}
